<template>
    <v-row>
        <v-col>
            <v-checkbox v-model="multiSelect" label="Multi-select" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, allows multiple values to be selected.</span>
        </v-col>
        <v-col>
            <v-text-field v-model="columns" type="number" label="Number of Columns" @input="emit" @change="emit"/>
            <span class="body-2 text--secondary">The number of columns to display the buttons in.</span>
        </v-col>
        <v-col>
            <v-select :items="[{text: 'Default', value: 'Default'}, {text: 'Ascending', value: 'asc'}, {text: 'Descending', value: 'desc'}]" v-model="sort" label="Sort Direction" @change="emit"/>
            <span class="body-2 text--secondary">How to sort the button values - default is what is returned by CS.</span>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'Buttons',
        data: () => ({
            multiSelect: true,
            columns: 3,
            sort: 'Default'
        }),
        methods: {
            emit() {
                let opts = {type: 'buttons', multiSelect: this.multiSelect};
                let cols = parseInt(this.columns);
                if(cols <= 0) {
                    cols = 3;
                }

                opts.columns = cols;

                if(this.sort != 'Default') {
                    opts.sortOptions = {
                        direction: this.sort
                    };
                }

                this.$emit('change', opts);
            }
        },
        created() {
            this.emit();
        }
    }
</script>

<style lang="scss" scoped>

</style>